import React, { useEffect, useState } from 'react';

import { Box, CircularProgress } from '@mui/material';

import { callGetFeatureJson } from 'handimap-react-lib/api/jsonFeatureApi';
import { SelectedTransportLineDetails } from 'handimap-react-lib/containers/SelectedDetails/SelectedTransportLineDetails';
import { SelectedFeaturePointDetails } from './SelectedFeaturePointDetails';

export const SelectedFeatureDetails = ({
  isMobile, 
  selectedFeature, 
  layer_id, 
  getFeatureInfoAttrs
}) => {
  /**
     * composant for check if feature is of type Point or Line
     */
  const [loadData, setLoadData] = useState(false);
  const [typeGeo, setTypeGeo] = useState(null);
  const [apiFeature, setApiFeature] = useState(null);

  useEffect(() => {
    setLoadData(true);
    callGetFeatureJson(layer_id, selectedFeature.properties.fid).then(
      result => {
        const {geometry} = result;
        setApiFeature(result);
        setTypeGeo(geometry.type);
      }
    ).catch(error => {
      console.log('error', error);
    });
    setLoadData(false);
    return () => {
      setTypeGeo(null);
    };
  }, [selectedFeature]);
  
  const renderFeatureDetails = () => {
    return (
      <React.Fragment>
        { (typeGeo.includes('LineString') && layer_id === 'lignes_transports') && ( 
          <SelectedTransportLineDetails
            isMobile={isMobile} 
            apiFeature={apiFeature}
            layerID={layer_id}
            getFeatureInfoAttrs={getFeatureInfoAttrs}
          />
        )}
        { typeGeo.includes('Point') && (
          <SelectedFeaturePointDetails  
            isMobile={isMobile} 
            apiFeature={apiFeature}
            layerID={layer_id}
            getFeatureInfoAttrs={getFeatureInfoAttrs}
          />
        )}
      </React.Fragment>
    );
  };

  const styles = {
    container: {
      display: 'flex',
      width: '100%',
      justifyContent: 'center'
    }
  };

  return (
    <Box sx={styles.container}>
      {(loadData || typeGeo === null) && (
        <CircularProgress color='secondary'/>
      )}
      {!loadData && typeGeo !== null && (renderFeatureDetails())}
    </Box>
  );
};